import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let pending = null;

export function fetchAppVersion() {
    if (!pending) {
        pending = api.get("/version").then((r) => r.data).catch(() => { pending = null; return null; });
    }
    return pending;
}

/** `{version, released_at, type, title}` of this deployment, or null while loading. */
export function useAppVersion() {
    const [info, setInfo] = useState(null);
    useEffect(() => {
        let alive = true;
        fetchAppVersion().then((d) => alive && setInfo(d));
        return () => { alive = false; };
    }, []);
    return info;
}

/** -1 / 0 / 1 for MAJOR.MINOR.PATCH strings; null when either is missing or malformed. */
export function compareVersions(a, b) {
    const pa = String(a || "").split(".").map(Number);
    const pb = String(b || "").split(".").map(Number);
    if (pa.length !== 3 || pb.length !== 3 || [...pa, ...pb].some((n) => !Number.isInteger(n))) return null;
    for (let i = 0; i < 3; i += 1) if (pa[i] !== pb[i]) return pa[i] < pb[i] ? -1 : 1;
    return 0;
}
